var accordions = [].slice.call(document.querySelectorAll('.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		Velocity(openAccordion.nextSibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');
	}
}

/*
* Footer accordion specific
* */
// Get all elements with class="accordion"

var acc = [].slice.call(document.querySelectorAll('#footer .accordion-footer'));


// Loop through the elements
for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        // Toggle between adding and removing the "active" class
        this.classList.toggle("active");

        // Get the panel element next to the clicked accordion
        var panel = this.nextElementSibling;

        console.log(panel.style.maxHeight)

        // Toggle between hiding and showing the panel
        if (panel.style.maxHeight || panel.classList.contains('open')) {
            panel.style.maxHeight = null;
            panel.style.opacity = 0;
            panel.classList.remove("open");

        } else {
            panel.classList.add("open");
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.style.opacity = 1;
        }
    });
}

/*=============================
=       Footer Accordion      =
=============================*/

var footerAccordion = [].slice.call(footer.querySelectorAll('.footer-top h4'));

footerAccordion.forEach(function(location) {
    location.addEventListener('click', function() {
        this.classList.toggle('open');

        Velocity(this.nextElementSibling, window.getComputedStyle(this.nextElementSibling).display === 'block' ? 'slideUp' : 'slideDown', {duration: 250});
    });
});
